<div class="h-screen bg-base lg:grid lg:grid-cols-[30%_70%]">
  <!-- Left marketing sidebar -->
  <aside
    class="relative isolate hidden min-h-[38vh] overflow-hidden bg-gradient-to-tr from-indigo700 to-indigo900 lg:flex lg:min-h-screen"
  >
    <div class="relative flex w-full flex-col text-white px-9 py-9">
      <div class="flex flex-col justify-between h-full">

        <!-- Brand -->
        <div class="flex items-center gap-3">
          <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-white/20 shrink-0">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 9L12 2L21 9V20C21 20.5523 20.5523 21 20 21H15V15H9V21H4C3.44772 21 3 20.5523 3 20V9Z" fill="white" fill-opacity="0.9"/>
            </svg>
          </div>
          <span class="text-[17px] font-semibold tracking-tight">Customer Portal</span>
        </div>

        <!-- Carousel card -->
        <div
          class="carousel-card w-full flex h-[600px] flex-col rounded-[14px] border border-white/20 bg-white/10 p-6 text-white shadow-[0_18px_50px_rgba(10,15,35,0.12)] backdrop-blur-[10px]"
          [class.slide-animate]="animateSlide()"
        >
          <p class="text-[34px] font-medium leading-[1.4] tracking-[0.01em] text-white">
            "{{ slides[currentSlide()] }}"
          </p>
          <div class="mt-auto flex items-center gap-2 pb-1">
            @for (slide of slides; track slide; let i = $index) {
              <button
                type="button"
                (click)="selectSlide(i)"
                class="h-2 rounded-full transition-all duration-300"
                [ngClass]="i === currentSlide() ? 'w-6 bg-white' : 'w-2 bg-white/45'"
                [attr.aria-label]="'Show slide ' + (i + 1)"
              ></button>
            }
          </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- Right form area -->
  <section class="flex w-full min-h-screen items-center justify-center bg-base px-[32px] py-10">
    <div class="flex w-full justify-center">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
